import { render } from "./bank-settings-list.vue?vue&type=template&id=e194c57e"
import script from "./bank-settings-list.vue?vue&type=script&lang=js"
export * from "./bank-settings-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__